import React from 'react'
import PropTypes from 'prop-types'

import BasePressIcon from './PressIcon.base'

const TodayShow = ({ className, ...props }) => (
  <BasePressIcon className={className} onClick={() => props.onClick('today_show')} box='0 0 715 172'>
    <g>
      <polygon points="251.44,65.92 274.95,65.92 274.95,130.91 297.24,130.91 297.24,65.92 320.62,65.92 320.62,46.39 251.44,46.39  "/>
      <g>
        <path d="M380.79,110.78c-2.75,1.23-5.86,1.86-9.23,1.86c-3.45,0-6.6-0.62-9.35-1.86c-2.76-1.23-5.13-2.94-7.05-5.07
          c-1.93-2.13-3.45-4.68-4.52-7.56c-1.07-2.88-1.61-6.06-1.61-9.44c0-3.38,0.54-6.55,1.61-9.44c1.07-2.88,2.59-5.42,4.52-7.56
          c1.93-2.14,4.3-3.84,7.05-5.07c2.75-1.23,5.89-1.86,9.35-1.86c3.37,0,6.47,0.62,9.23,1.86c2.75,1.23,5.12,2.94,7.05,5.07
          c1.93,2.14,3.45,4.68,4.52,7.56c1.07,2.89,1.61,6.06,1.61,9.44c0,3.38-0.54,6.55-1.61,9.44c-1.07,2.88-2.59,5.42-4.52,7.56
          C385.92,107.84,383.55,109.54,380.79,110.78 M403.79,57.23c-3.99-3.83-8.81-6.85-14.31-9c-5.5-2.14-11.53-3.23-17.91-3.23
          c-6.46,0-12.51,1.09-17.97,3.23c-5.46,2.14-10.27,5.17-14.31,8.99c-4.04,3.83-7.24,8.48-9.51,13.81
          c-2.27,5.34-3.42,11.29-3.42,17.67c0,6.38,1.15,12.33,3.42,17.67c2.27,5.34,5.47,9.99,9.51,13.82c4.03,3.82,8.85,6.85,14.31,8.99
          c5.46,2.14,11.51,3.23,17.97,3.23c6.38,0,12.41-1.09,17.91-3.23c5.51-2.15,10.32-5.17,14.31-9c4-3.83,7.17-8.48,9.44-13.81
          c2.27-5.34,3.42-11.28,3.42-17.67c0-6.38-1.15-12.33-3.42-17.67C410.96,65.71,407.79,61.06,403.79,57.23"/>
        <path d="M488.5,88.59c0,3.04-0.52,5.98-1.55,8.74c-1.03,2.76-2.53,5.19-4.46,7.24c-1.93,2.05-4.34,3.72-7.18,4.95
          c-2.83,1.23-6.11,1.86-9.73,1.86h-13.24V65.92h13.36c3.79,0,7.15,0.58,9.99,1.73c2.83,1.15,5.22,2.77,7.11,4.82
          c1.89,2.05,3.32,4.46,4.27,7.17C488.03,82.37,488.5,85.37,488.5,88.59 M498.26,57.67c-4.03-3.62-8.88-6.43-14.42-8.36
          c-5.54-1.93-11.7-2.91-18.31-2.91h-35.48v84.51h35.6c6.54,0,12.65-0.98,18.18-2.91c5.54-1.93,10.39-4.77,14.42-8.43
          c4.04-3.66,7.23-8.14,9.49-13.31c2.27-5.18,3.42-11.12,3.42-17.67c0-6.55-1.15-12.49-3.42-17.67
          C505.49,65.75,502.3,61.29,498.26,57.67"/>
      </g>
      <path d="M568.57,99.31h-20.43l10.21-30.16L568.57,99.31z M572.16,46.39h-27.62l-31.63,84.06l-0.17,0.46h25.24l4.15-12.07h32.58
        l4.15,12.07h25.24l-31.85-84.3L572.16,46.39z"/>
      <polygon points="655.82,46.39 638.04,76.98 620.11,46.56 620.01,46.39 594.82,46.39 626.89,96.86 626.89,130.91 649.19,130.91 
        649.19,96.86 681.14,46.39   "/>
    </g>
    <g>
      <g>
        <path d="M135.44,33.25c-52.12,0-94.69,40.92-97.31,92.39c-0.09,1.67-0.13,3.35-0.13,5.05h25.26c0-1.64,0.06-3.28,0.17-4.89
          c2.52-37.53,33.85-67.29,72.01-67.29c38.3,0,69.73,29.99,72.04,67.72c0.09,1.47,0.14,2.96,0.14,4.45h25.26
          c0-1.34-0.02-2.67-0.08-4C230.71,74.73,187.92,33.25,135.44,33.25"/>
        <path d="M135.44,65.73c-34.44,0-62.61,26.8-64.82,60.68c-0.09,1.42-0.14,2.84-0.14,4.28h25.26c0-1.56,0.09-3.09,0.27-4.6
          c2.29-19.73,19.1-35.1,39.43-35.1c20.44,0,37.32,15.53,39.47,35.4c0.16,1.41,0.23,2.84,0.23,4.29h25.26
          c0-1.39-0.04-2.76-0.13-4.13C198.14,92.6,169.93,65.73,135.44,65.73"/>
        <path d="M135.44,98.21c-15.84,0-29.03,11.33-31.9,26.33c-0.39,1.99-0.58,4.04-0.58,6.15h64.96c0-1.57-0.11-3.11-0.33-4.62
          C165.35,110.31,151.82,98.21,135.44,98.21"/>
      </g>
    </g>
  </BasePressIcon>
)

TodayShow.propTypes = {
  className: PropTypes.string
}

export default TodayShow



// WEBPACK FOOTER //
// ./src/core/icons/press/TodayShow.base.js